import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const CONTRACT_STATUS_COLORS = {
  "Open": "bg-red-100 text-red-700 border-red-200",
  "Reviewed": "bg-blue-100 text-blue-700 border-blue-200",
  "Negotiating": "bg-amber-100 text-amber-700 border-amber-200",
  "Pending CEO Signature": "bg-yellow-100 text-yellow-700 border-yellow-200",
  "Pending GC Signature": "bg-purple-100 text-purple-700 border-purple-200",
  "Handoff Requested": "bg-green-100 text-green-700 border-green-200",
  "Closed": "bg-white text-slate-600 border-slate-200",
};

const DEFAULT = "bg-slate-100 text-slate-600 border-slate-200";

export function ContractStatusBadge({ status }) {
  if (!status) return <span className="text-sm text-muted-foreground">--</span>;
  const colorClass = CONTRACT_STATUS_COLORS[status] || DEFAULT;
  return (
    <Badge
      data-testid={`contract-status-badge-${status.toLowerCase().replace(/\s+/g, '-')}`}
      className={cn(
        "rounded-full px-2.5 py-0.5 text-[11px] font-medium border whitespace-nowrap shadow-none",
        colorClass
      )}
    >
      {status}
    </Badge>
  );
}

export const CONTRACT_ROW_COLORS = {
  "Open": "bg-red-50/70",
  "Reviewed": "bg-blue-50/70",
  "Negotiating": "bg-amber-50/70",
  "Pending CEO Signature": "bg-yellow-50/70",
  "Pending GC Signature": "bg-purple-50/70",
  "Handoff Requested": "bg-green-50/70",
  "Closed": "",
};
